import { render } from "./HeroiconsOutlineArrowCircleDown.vue?vue&type=template&id=5e766de2"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowCircleDown.vue"]])

export default __exports__